import React from 'react';
import styled from 'styled-components';
import AdminUserManagementComponent from 'Components/AdminPage/AdminUserManagement';
import EducationLayout from 'Components/Layout/EducationLayout';

const ContentContainer = styled.div`
  width: 100%;
  margin: 20px;
  overflow: auto;
  flex: 1;
`;

const EducationUserManagement = () => {
  return (
    <EducationLayout>
      <ContentContainer>
        <AdminUserManagementComponent />
      </ContentContainer>
    </EducationLayout>
  );
};
export default EducationUserManagement;
